export enum PriceDisplayTypes {
  CYCLE = "min",
  MONTHLY_FROM = "abs_min",
  LOWEST_MONTHLY_PRICE = "lowest_monthly_price"
}
